import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=0067f0b6&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"
import style0 from "./Search.vue?vue&type=style&index=0&id=0067f0b6&prod&lang=less&scoped=true"
import style1 from "./Search.vue?vue&type=style&index=1&id=0067f0b6&prod&lang=css"
import style2 from "./Search.vue?vue&type=style&index=2&id=0067f0b6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0067f0b6",
  null
  
)

export default component.exports